import React, {useState} from "react";
import {arePreloaded, preload} from "../../../travian/worldData";
import {LoadingScreen} from "../loadingScreen";

/**
 * Wrapper component for anything. Ensures that children are only rendered, if the requested in-game world data are already loaded to client.
 */
export default function WorldDataLoader({ types, children }) {
    const [isLoaded, setIsLoaded] = useState(arePreloaded(types));

    if(!isLoaded) {
        preload(types).then(() => setIsLoaded(true));
        return <LoadingScreen />
    }

    return <>{children}</>
}
